import React from "react";
import { Container, Row, Col } from "shards-react";
import AuthorizationMatrixAudit from "../components/contracts/authorizationMatrices/audit";

const AuthorizationMatrixAuditTable = () => (
  <Container fluid className="main-content-container px-4">
	  <Row>
      <Col className="p-2">
		    <AuthorizationMatrixAudit /> 
      </Col>
    </Row>
   </Container>
);

export default AuthorizationMatrixAuditTable;
